<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="d7e290">
<h1 class="chapno">Part I</h1>
<a id="p1">
<h2 class="chapttl" id="d7e291">The ABCs of Reverse Mortgages</h2>
<p class="tx1" id="d7e293">
</p></a></div><a id="p1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Krae_9781440501029_epub_p1.vue?d2bd2048